import { forwardRef } from "react";

type TextAreaProps = {
  maxChars?: number;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ maxChars, ...props }, ref) => {
    const currentCount = String(props.value ?? "").length;
    const isOver = maxChars !== undefined && currentCount > maxChars;

    return (
      <div style={{ width: "100%" }}>
        <textarea
          ref={ref}
          {...props}
          className={`${props.className ?? ""}${isOver ? " error-input-red" : ""}`}
        />
        {maxChars !== undefined && isOver && (
          <span className="field-error">
            Please limit your response to {maxChars} characters ({currentCount}/
            {maxChars})
          </span>
        )}
      </div>
    );
  },
);

export default TextArea;
